import React, { useState, useRef, useEffect } from "react";
import Footer from "../components/Footer/Footer";
import axios from "axios";
import { useStateContext } from "../contexts/ContextProvider";

const Referral = () => {
  const { loading, numberOfContests, getAllContests } = useStateContext();
  const [confirmText, setConfirmText] = useState("");
  const [buttonText, setButtonText] = useState("Get Code");
  const emailRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    getReferral(emailRef.current.value);
  };

  useEffect(() => {
    getAllContests();
  }, []);

  const getReferral = (email) => {
    try {
      setButtonText("Loading...");
      axios
        .get(
          `${process.env.REACT_APP_BACKEND_API_SERVER}/referral?email=${email}`
        )
        .then(
          (response) => {
            console.log(response.data);
            if (response.status === 200) {
              setConfirmText(
                "Check your email for referral code and instructions."
              );
              emailRef.current.value = "";
              setButtonText("Get Code");
            } else {
              alert("Something went wrong!");
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } catch (error) {
      console.error(error);
    }
  };

  if (loading || numberOfContests === -1)
    return <p className="text-center bg-blue-600 text-white">Loading...</p>;

  return (
    <>
      <div className="App">
        <div className="">
          <div className="flex justify-center items-center content-center border-2 border-transparent">
            <div className="font-serif text-white text-center border-2 border-transparent w-2/3">
              <div>
                <h2 className="text-white font-semibold text-3xl uppercase">
                  GET REFERRAL CODE
                </h2>
                <h3 className="text-xl mt-8">
                  Share your SoundOff referral code with friends and win free song
                  ads when they enter contests!
                </h3>
              </div>
            </div>
          </div>
          <div className="justify-center items-center content-center text-center">
            <form onSubmit={(e) => handleSubmit(e)}>
              <div className="flex space-x-2 justify-center mt-8">
                {/* <div className="text-white text-center w-full m-3 mb-5">
                  <label className="text-lg">Email</label>
                </div> */}
                <input
                  type="email"
                  name="email"
                  ref={emailRef}                  
                  placeholder="Enter your email"
                  className="bg-black inline-block border-2 border-indigo-600 px-6 py-2 text-white font-medium lg:text-lg md:text-md text-sm rounded-md"
                />
              </div>
              <div className="space-x-2 justify-center mt-8">
                <button
                  type="submit"                  
                  className="inline-block px-6 py-2 bg-indigo-600 text-white font-semibold lg:text-lg md:text-md text-sm rounded-md hover:bg-indigo-600 cursor-pointer"
                >
                  {buttonText}
                </button>
              </div>
            </form>
            <h3 className="text-xl text-white mx-12 mt-6">{confirmText}</h3>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Referral;
